module.exports = __webpack_public_path__ + "static/media/skull-crossbones.b09a4818.svg";